import { ThemeProviderProps } from '@emotion/react'
import { useMediaQuery } from '@mui/material'
import ThemeTopLayout from 'gatsby-theme-material-ui-top-layout/src/components/top-layout'
import React from 'react'
import { lightTheme, darkTheme } from '../theme'

const TopLayout: React.FC<ThemeProviderProps> = ({ children }) => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')

  const adjustedTheme = React.useMemo(() => (prefersDarkMode ? darkTheme : lightTheme), [prefersDarkMode])

  return <ThemeTopLayout theme={adjustedTheme}>{children}</ThemeTopLayout>
}

export default TopLayout
